import lodashModule from 'lodash';

export const { debounce, cloneDeep } = lodashModule;
